import React, { useState, useEffect, useRef } from "react";
import { Box, CardContent, Tab, Tabs, Typography } from "@mui/material";
import { StyledCard } from "../../assets/styled-components/StyledCard";
import { LineChart } from "@mui/x-charts/LineChart";

const TopAssetsByWorkOrderCount = ({ responseFem, responseBem }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [topAssets, setTopAssets] = useState([]);
  const chartRef = useRef(null);

  const handleTabChange = (_event, newValue) => {
    setSelectedTab(newValue);
  };

  // Function to get top 5 assets based on work order count
  const getTopAssetsByWorkOrderCount = (response) => {
    if (!response || !response.topAssetbyWOcountLists) return [];

    return response.topAssetbyWOcountLists
      .sort((a, b) => b.count - a.count)
      .slice(0, 5); // Top 5 assets by work order count
  };

  // Update the top assets when the selected tab changes
  useEffect(() => {
    if (selectedTab === 0) {
      setTopAssets(getTopAssetsByWorkOrderCount(responseFem));
    } else {
      setTopAssets(getTopAssetsByWorkOrderCount(responseBem));
    }
  }, [selectedTab, responseFem, responseBem]);

  // Prepare chart data for LineChart
  const chartData = {
    dataset: topAssets.map((item) => ({
      assetNo: item.assetNo,
      workOrderCount: item.count,
    })),
  };

  useEffect(() => {
    if (chartRef.current) {
      // Select the tspan element
      const tspanElement = chartRef.current.querySelector(
        ".MuiChartsAxis-label tspan"
      );
      if (tspanElement) {
        tspanElement.setAttribute("dy", "-10px"); // Change the dy value
      }
    }
  }, [topAssets]);

  return (
    <StyledCard>
      <CardContent>
        <Typography
          mb={1.5}
          variant="h5"
          fontWeight={700}
          color={"text.primary"}
        >
          Top Assets by Work Order Count
        </Typography>

        {/* Tabs */}
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          aria-label="Top Assets by Work Order Count"
        >
          <Tab label="FEMS" />
          <Tab label="BEMS" />
        </Tabs>

        {/* Chart container */}
        <Box mt={2} style={{ height: 300 }} ref={chartRef}>
          <LineChart
            dataset={chartData.dataset}
            xAxis={[
              {
                scaleType: "band",
                dataKey: "assetNo",
                tickLabelStyle: {
                  angle: -45,
                  textAnchor: "end",
                  dominantBaseline: "middle",
                },
              },
            ]}
            yAxis={[
              {
                scaleType: "linear",
                dataKey: "workOrderCount",
                label: "Work Orders",
                min: 0,
                max: Math.max(...topAssets.map((asset) => asset.count), 300),
                margin: { left: 120 },
              },
            ]}
            series={[
              { dataKey: "workOrderCount", area: true, color: "#6f42c1",label:'Assets' },
            ]}
            point={{ size: 10, shape: "circle" }}
            layout="horizontal"
            smoothing="smooth"
            grid={{ horizontal: true }}
            margin={{ bottom: 100 }}
            slotProps={{ legend: { hidden: true } }}
          />
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default TopAssetsByWorkOrderCount;
